module.exports = __webpack_public_path__ + "392c492bc2201576260c3b0678a17bd7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/magnifier-white.png
// module id = 3699
// module chunks = 0